export default "__VITE_ASSET__ddc29690__"